import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import {fieldIssueTypesType} from '../../constants/proptype-validation';
import SelectBoxAdapter from '../common/SelectBoxAdapter';

const getEmptyState = rootCauses => (rootCauses.length ? i18n.t('new.noAvailableRootCauses') : undefined);

const IssueRootCauseDropdown = ({
  className,
  activeIssueRootCausesGroupedDropdownOptions,
  rootCauseEntitiesMap,
  dropdownMaxWidth,
  selectedOptionId,
  valid,
  disabled,
  clearable,
  onChange
}) => (
  <SelectBoxAdapter
    className={className}
    options={activeIssueRootCausesGroupedDropdownOptions}
    selectedOptions={selectedOptionId ? rootCauseEntitiesMap[selectedOptionId] : ''}
    labelKey="title"
    valueKey="id"
    dropdownMaxWidth={dropdownMaxWidth}
    valid={valid}
    disabled={disabled}
    onChange={onChange}
    clearable={clearable}
    grouped
    searchable
    searchIcon
    searchPlaceholder={i18n.t('new.search')}
    noResultsValue={getEmptyState(activeIssueRootCausesGroupedDropdownOptions)}
  />
);

IssueRootCauseDropdown.displayName = 'IssueCreateFormSelectDropdown';

IssueRootCauseDropdown.defaultProps = {
  dropdownMaxWidth: 250
};

IssueRootCauseDropdown.propTypes = {
  className: PropTypes.string,
  selectedOptionId: PropTypes.string,
  activeIssueRootCausesGroupedDropdownOptions: PropTypes.array.isRequired,
  rootCauseEntitiesMap: fieldIssueTypesType.isRequired,
  disabled: PropTypes.bool,
  dropdownMaxWidth: PropTypes.number,
  clearable: PropTypes.bool,
  valid: PropTypes.bool,
  scrollableContainer: PropTypes.object,
  onChange: PropTypes.func.isRequired
};

export default IssueRootCauseDropdown;
